import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import { PageTypes } from '../constants/Pages.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import './getAuthIdParam.js';
import 'react';
import 'react-cookie';
import './formatDate.js';
import '../constants/StateList.js';
import './getTransporterFigure.js';
import './getDownloadsFigure.js';
import 'lodash.isequal';
import './getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../constants/serviceTypeId.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';

const getPageType = (path) => {
    if (path === "/")
        return PageTypes.HOMEPAGE;
    else if (path.includes(PageTypes.MARKETPLACE))
        return PageTypes.MARKETPLACE;
    else if (path.includes(PageTypes.TRANSPORTERS))
        return PageTypes.TRANSPORTERS;
    else if (path.includes(PageTypes.GROW_NETWORK))
        return PageTypes.GROW_NETWORK;
    else
        return path.replace(/\//g, "");
};

export { getPageType };
//# sourceMappingURL=getPageType.js.map
